import { Box, Card, Skeleton, useMediaQuery } from "@mui/material";

import { theme } from "@/src/theme/theme";

export const ArticleCardSkeleton = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Card
      sx={{
        background: "none",
        boxShadow: "none",
        marginBottom: 2,
        maxWidth: isMobile ? "460px" : "100%",
        px: 2,
        mx: "auto"
      }}
    >
      <Box sx={{ width: "100%", aspectRatio: "16 / 9", marginBottom: 2 }}>
        <Skeleton
          variant="rectangular"
          width="100%"
          height="100%"
          sx={{ borderRadius: 1 }}
        />
      </Box>
      <Skeleton variant="text" width="40%" height={20} sx={{ mb: 1 }} />
      <Skeleton variant="text" width="90%" height={30} sx={{ mb: 0.5 }} />
      <Skeleton variant="text" width="100%" height={20} />
      <Skeleton variant="text" width="100%" height={20} />
      <Skeleton variant="text" width="80%" height={20} />
    </Card>
  );
};
